import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '../../dialog.jsx';

export default class Prepare extends React.Component {
    static propTypes = {
        job: PropTypes.object,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { job } = nextProps;
        if (job.stage === 'DONE') {
            nextProps.onReady();
        }
    }

    render() {
        const { job } = this.props;

        let h1 = 'Preparing to print...';
        let progress;
        if (job.stage === 'DOWNLOADING') {
            h1 = 'Fetching pages';
            progress = `${job.percent}%`;
        }

        return (
            <Dialog
                focusDialog
                underlayClickExits={false}
                closeButton={false}
                title="Print"
            >
                <div className="loading-container">
                    <div className="loading-block">
                        <div className="loading">
                            <h1>{h1}</h1>
                            <p>{progress}</p>
                            <span className="ball1" />
                            <span className="ball2" />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/engage_reader/print_dialog/prepare.jsx